import type {
    ListDataType,
    MerchantCoverType,
    MerchantDetailType,
    MerchantCabinetType,
    ResponseWithMessage,
    MerchantCabinetCreateType,
    MerchantCabinetUpdateType,
    MerchantUpdateType,
} from "@src/types";
import { privateApi } from "./client";

export async function getMerchantCabinetsApi(
    signal?: AbortSignal,
): Promise<ListDataType<MerchantCabinetType>> {
    const { data } = await privateApi.get<ListDataType<MerchantCabinetType>>(
        "/api/merchant-cabinets/list/by-user",
        {
            signal,
        },
    );
    return data;
}

export async function getMerchantsApi(
    signal?: AbortSignal,
): Promise<ListDataType<MerchantCoverType>> {
    const { data } = await privateApi.get<ListDataType<MerchantCoverType>>(
        "/api/merchants/list/by-user",
        {
            signal,
        },
    );
    return data;
}

export async function getMerchantsByCabinetApi(
    params: {
        merchant_cabinet_id?: string;
    },
    signal?: AbortSignal,
): Promise<ListDataType<MerchantDetailType>> {
    const { data } = await privateApi.get<ListDataType<MerchantDetailType>>(
        `/api/merchants/list-detailed`,
        { params, signal },
    );
    return data;
}

export async function merchantCabinetCreateApi(
    payload: MerchantCabinetCreateType,
): Promise<ResponseWithMessage> {
    const { data } = await privateApi.post<ResponseWithMessage>(
        "/api/merchant-cabinets/register",
        payload,
    );
    return data;
}

export async function merchantCabinetUpdateApi(
    pk: string,
    payload: MerchantCabinetUpdateType,
): Promise<MerchantCabinetType> {
    const { data } = await privateApi.put<MerchantCabinetType>(
        `/api/merchant-cabinets/${pk}/update`,
        payload,
    );
    return data;
}

export async function merchantUpdateApi(
    pk: string,
    payload: MerchantUpdateType,
): Promise<MerchantDetailType> {
    const { data } = await privateApi.put<MerchantDetailType>(
        `/api/merchants/${pk}/update`,
        payload,
    );
    return data;
}
